(() => {
  const focusableSelector =
    'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const getGuideFromOpener = (opener) => {
    const controlledId = opener.getAttribute('aria-controls');
    if (controlledId) return document.getElementById(controlledId);

    const section = opener.closest('[data-dp-hero-root]');
    if (!section) return null;

    const sectionId = section.id.replace('DarPrirodeHero-', '');
    return document.getElementById(`DarPrirodeGuide-${sectionId}`);
  };

  const closeGuide = (guide, restoreFocus = true) => {
    if (!guide) return;

    guide.classList.remove('is-open');
    guide.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('dp-guide-lock');

    window.setTimeout(() => {
      guide.hidden = true;
    }, 320);

    if (restoreFocus) {
      guide._dpPreviousFocus?.focus?.();
    }
  };

  const openGuide = (guide, key, opener) => {
    if (!guide || !key) return;

    let activePanel = null;

    guide.querySelectorAll('[data-dp-guide-panel]').forEach((panel) => {
      const active = panel.dataset.dpGuidePanel === key;
      panel.hidden = !active;
      if (active) activePanel = panel;
    });

    if (!activePanel) return;

    guide._dpPreviousFocus = opener || document.activeElement;
    guide.querySelector('[data-dp-guide-status]').textContent = '';
    guide.hidden = false;
    guide.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('dp-guide-lock');
    guide.querySelector('.dp-guide__scroll')?.scrollTo({ top: 0, behavior: 'auto' });

    window.requestAnimationFrame(() => {
      guide.classList.add('is-open');
      guide.querySelector('[data-dp-guide-close]')?.focus({ preventScroll: true });
    });
  };

  document.addEventListener('click', async (event) => {
    const opener = event.target.closest('[data-dp-guide-open]');
    if (opener) {
      event.preventDefault();
      openGuide(getGuideFromOpener(opener), opener.dataset.dpGuideOpen, opener);
      return;
    }

    const closeButton = event.target.closest('[data-dp-guide-close]');
    if (closeButton) {
      closeGuide(closeButton.closest('[data-dp-guide]'));
      return;
    }

    const quizButton = event.target.closest('[data-dp-guide-quiz]');
    if (quizButton) {
      const guide = quizButton.closest('[data-dp-guide]');
      const sectionId = guide?.dataset.sectionId || '';
      const mode = quizButton.dataset.quizMode || 'all';
      const prefill = quizButton.dataset.quizPrefill || '';

      closeGuide(guide, false);

      window.setTimeout(() => {
        document.dispatchEvent(
          new CustomEvent('dp:quiz:open', {
            detail: { sectionId, mode, prefill, opener: quizButton }
          })
        );
      }, 260);
      return;
    }

    const addButton = event.target.closest('[data-dp-guide-add]');
    if (!addButton || addButton.disabled) return;

    const guide = addButton.closest('[data-dp-guide]');
    const status = guide?.querySelector('[data-dp-guide-status]');
    const variantId = Number(addButton.dataset.variantId || 0);
    const originalText = addButton.textContent;

    if (!variantId) return;

    addButton.disabled = true;
    addButton.textContent = 'Dodajem...';
    if (status) status.textContent = '';

    try {
      if (!window.DarPrirodeCart) {
        throw new Error('Sistem korpe nije učitan.');
      }

      await window.DarPrirodeCart.addItems(
        [{ id: variantId, quantity: 1 }],
        'dar-prirode-guide'
      );

      addButton.textContent = 'Dodano ✓';
      if (status) status.textContent = 'Proizvod je dodan u korpu.';

      window.setTimeout(() => {
        closeGuide(guide, false);
        window.DarPrirodeCart.openDrawer();
      }, 480);
    } catch (error) {
      addButton.disabled = false;
      addButton.textContent = originalText;
      if (status) {
        status.textContent = error?.message || 'Došlo je do greške. Pokušajte ponovo.';
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    const guide = event.target.closest?.('[data-dp-guide]');
    if (!guide || guide.hidden) return;

    if (event.key === 'Escape') {
      closeGuide(guide);
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = [...guide.querySelectorAll(focusableSelector)].filter(
      (node) => !node.closest('[hidden]') && node.offsetParent !== null
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
